/** Format seconds into human-readable duration, e.g. 302 → "5m 2s" */
export function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null) return '—'
  if (seconds === 999999) return 'auto'
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  if (h > 0) return `${h}h ${m}m ${s}s`
  if (m > 0) return `${m}m ${s}s`
  return `${s}s`
}

/** Format metres to km, e.g. 1200 → "1.2km" */
export function formatMetres(metres: number | null | undefined): string {
  if (metres == null) return '—'
  if (metres < 1000) return `${metres}m`
  return `${(metres / 1000).toFixed(1)}km`
}

/** CSS classes for clickable entity references in tables */
export const entityRefClass = 'inline-flex items-center rounded-md border bg-muted/50 px-1.5 py-0.5 text-sm underline underline-offset-2 hover:bg-muted transition-colors'

function normalizeApiDateTime(value: string): string {
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(value)
    ? `${value}Z`
    : value
}

export function parseApiDateTime(value: string | null | undefined): Date | null {
  if (!value) return null

  const date = new Date(normalizeApiDateTime(value))
  return Number.isNaN(date.getTime()) ? null : date
}

/** Format UTC epoch timestamp to Brisbane timezone string */
export function formatEpoch(epoch: number | null | undefined): string {
  if (epoch == null) return '—'
  return new Date(epoch * 1000).toLocaleString('en-AU', {
    timeZone: 'Australia/Brisbane',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
}

/** Format an ISO datetime using the browser's local timezone */
export function formatBrowserDateTime(value: string | null | undefined): string {
  const date = parseApiDateTime(value)
  if (!date) return value || '—'

  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    timeZone: browserTimeZone,
    timeZoneName: 'short',
  }).format(date)
}
